import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clientVerificationApi, ClientVerifyData } from '../api/clientVerificationApi';
import { queryKeys, invalidateEntityQueries } from '@/shared/lib/react-query';

export function useClientVerification(clientId: string) {
  const queryClient = useQueryClient();

  const getDocumentsArchiveUrl = useMutation({
    mutationFn: () => clientVerificationApi.getDocumentsArchiveUrl(clientId),
  });

  const acceptVerification = useMutation({
    mutationFn: (data: ClientVerifyData) => clientVerificationApi.acceptVerification(clientId, data),
    onSuccess: async () => {
      // Инвалидируем конкретного клиента и весь список
      await queryClient.invalidateQueries({
        queryKey: queryKeys.clients.detail(clientId)
      });
      await invalidateEntityQueries.clients(queryClient);
    },
  });

  const declineVerification = useMutation({
    mutationFn: () => clientVerificationApi.declineVerification(clientId),
    onSuccess: async () => {
      // Инвалидируем конкретного клиента и весь список
      await queryClient.invalidateQueries({
        queryKey: queryKeys.clients.detail(clientId)
      });
      await invalidateEntityQueries.clients(queryClient);
    },
  });

  return {
    getDocumentsArchiveUrl,
    acceptVerification,
    declineVerification,
  };
}
